module.exports = {"370832001":"水泊街道","370832002":"梁山街道","370832101":"小路口镇","370832102":"韩岗镇","370832104":"拳铺镇","370832105":"杨营镇","370832106":"韩垓镇","370832107":"馆驿镇","370832108":"小安山镇","370832109":"寿张集镇","370832110":"黑虎庙镇","370832111":"马营镇","370832215":"赵堌堆乡","370832217":"大路口乡","370832400":"梁山经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370832.json
// module id = 1433
// module chunks = 0